import Text from '../main/Text';
import Day from './Day';
import { IOpeningHour } from '../../interfaces';
import { groupOpeningHours, weekdayShort } from '../../utils/openingHours';
import { getTranslatedLabel } from '../../utils/translations';

function Schedule({ openingHours }: { openingHours: IOpeningHour[]} ) 
{
    return (
        <div style = {{ display: 'flex', flexDirection: 'column', gap: '1px' }}>
            <Text
                text = {getTranslatedLabel('Working time')}
                fontSize = {16}
                fontWeight = {700}
            />

        {
            groupOpeningHours(openingHours).map(({ day, slots }) =>
                <Day
                    key = {`${day}-${slots.map(s => s.open + s.close).join('_')}`}
                    day = {weekdayShort(day)}
                    slots = {slots}
                />
            )
        }
        </div>
    )
}

export default Schedule;